import { Button, DataSource, HorizontalSpacer, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPnnCodeManuallyAdd extends Layout {
    buttonSave: Button;
    horizontalspacer1: HorizontalSpacer;
    sourceAllLoadboardServices: DataSource;
    sourceEquipmentType: DataSource;
    textboxDescription: Textbox;
    textboxPnnCode: Textbox;
    textboxTruckStopCode: Textbox;
}
